module.exports = __webpack_public_path__ + "img/area-huadong.cb68749d.png";